import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { noop } from 'lodash';
import createMemoizedContextProvider from './CreateMemoizedContextProvider';

const { useContext: useAgentsContext, Provider } = createMemoizedContextProvider('AgentsContextProvider');

export const AgentsContextProvider = ({
    children,
    wirelessAgents,
    defaultAgents,
    availableAgents,
    matchingTaggedAgents,
    setAvailableAgents,
    setMatchingTaggedAgents,
}) => {
    const contextValue = useMemo(
        () => ({
            wirelessAgents,
            defaultAgents,
            availableAgents,
            matchingTaggedAgents,
            setAvailableAgents,
            setMatchingTaggedAgents,
        }),
        [
            wirelessAgents,
            defaultAgents,
            availableAgents,
            matchingTaggedAgents,
            setAvailableAgents,
            setMatchingTaggedAgents,
        ]
    );
    return <Provider value={contextValue}>{children}</Provider>;
};

AgentsContextProvider.propTypes = {
    children: PropTypes.node,
    wirelessAgents: PropTypes.array,
    defaultAgents: PropTypes.array,
    availableAgents: PropTypes.array,
    matchingTaggedAgents: PropTypes.array,
    setAvailableAgents: PropTypes.func,
    setMatchingTaggedAgents: PropTypes.func,
};

AgentsContextProvider.defaultProps = {
    children: null,
    wirelessAgents: [],
    defaultAgents: [],
    availableAgents: [],
    matchingTaggedAgents: [],
    setAvailableAgents: noop,
    setMatchingTaggedAgents: noop,
};

export default useAgentsContext;
